// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ye1wLseMX11pPCk0e3eh{color:#076418}.s5ila9TOZnST8B1IwjzO{color:#ffab45}.IhoYo71_8v5jxPSbVDHf{color:#d93115}.iAqDB_cjURQUkZZxab5G{color:#c70700}`, "",{"version":3,"sources":["webpack://./src/js/components/cards/common/_pathogenicityColors.module.scss"],"names":[],"mappings":"AAAA,sBACE,aAAA,CAEF,sBACE,aAAA,CAEF,sBACE,aAAA,CAEF,sBACE,aAAA","sourcesContent":[".Benign{\n  color:#076418;\n}\n.UncertainSignificance{\n  color:#ffab45;\n}\n.LikelyPathogenic{\n  color:#d93115;\n}\n.Pathogenic{\n  color:#c70700;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Benign": `Ye1wLseMX11pPCk0e3eh`,
	"UncertainSignificance": `s5ila9TOZnST8B1IwjzO`,
	"LikelyPathogenic": `IhoYo71_8v5jxPSbVDHf`,
	"Pathogenic": `iAqDB_cjURQUkZZxab5G`
};
export default ___CSS_LOADER_EXPORT___;
